import { render, staticRenderFns } from "./pos_group_view.vue?vue&type=template&id=fa50b782&scoped=true&"
import script from "./pos_group_view.vue?vue&type=script&lang=js&"
export * from "./pos_group_view.vue?vue&type=script&lang=js&"
import style0 from "./pos_group_view.vue?vue&type=style&index=0&id=fa50b782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa50b782",
  null
  
)

export default component.exports